import { render, staticRenderFns } from "./FcWysiwyg.vue?vue&type=template&id=56046719&"
import script from "./FcWysiwyg.vue?vue&type=script&lang=ts&"
export * from "./FcWysiwyg.vue?vue&type=script&lang=ts&"
import style0 from "./FcWysiwyg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports